import React, { useState, useEffect } from 'react';
import './Driver.scss'
import Header from '../header/Header';
import Button from '../../../components/button/Button';
import List from '../../../components/list/List';
import { useHistory } from 'react-router-dom';
import Titlebar from '../../../components/titlebar/Titlebar';
import { getDriverList } from '../../../utils/apis/services/api';
import Pagination from "react-js-pagination";
import ContentLoader from "react-content-loader"
import  translate from '../../../utils/locale/language'
import { setDriverSelection,getDriverSelection,setPageSelection,getPageSelection} from "../../../../src/utils/common"

/* eslint-disable react-hooks/exhaustive-deps */
const QUERY_FOR = { 1: "in-review", 2: "approved", 3: "on-hold", 4: "rejected" };

const Driver = (props) => {
  let [list, setList] = useState(1);
  const [approvedDrivers, setApprovedDrivers] = useState([]);
  const [OnHoldDrivers, setOnHoldDrivers] = useState([]);
  const [rejectedDrivers, setRejectedDrivers] = useState([]);
  const [inReviewRequest, setInReviewRequest] = useState([]);
  const [requestListTmpInReview, setRequestListTmpInReview] = useState([]);
  const [requestListTmpApproved, setRequestListTmpApproved] = useState([]);
  const [, setRequestListTmpOnHold] = useState([]);
  const [requestListTmpRejected, setRequestListTmpRejected] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(1);
  var [activePage, setPage] = useState(1);

  const setters = {
    1: [setInReviewRequest, setRequestListTmpInReview],
    2: [setApprovedDrivers, setRequestListTmpApproved],
    3: [setOnHoldDrivers, setRequestListTmpOnHold],
    4: [setRejectedDrivers, setRequestListTmpRejected]
  };

  const fetchDriverList = async (tabIndex, pageNumber, searchQuery = "") => {
    const queryFor = QUERY_FOR[tabIndex];
    if (!queryFor) return;
    setPageSelection(pageNumber);
    setLoading(true);
    const result = await getDriverList(queryFor, pageNumber, searchQuery);
    setLoading(false);
    const res = result?.data?.ResponseData;
    const results = Array.isArray(res?.data) ? res.data : (res?.results ?? []);
    const cnt = res?.count ?? results.length;
    setCount(cnt);
    const [setItems, setTmp] = setters[tabIndex];
    if (setItems) setItems(results);
    if (setTmp && res) setTmp(res);
  };

  const handleRequestData = (data) => {
    fetchDriverList(data, getPageSelection() || 1, input);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
    fetchDriverList(list, pageNumber, input);
  };

  const onSearch = (value) => {
    setInput(value);
  };

  const filterBySearch = (data) => {
    if (!input || !input.trim()) return data;
    const q = input.trim().toLowerCase();
    return (data || []).filter(
      (item) =>
        (item.full_name || "").toLowerCase().includes(q) ||
        (item.email || "").toLowerCase().includes(q) ||
        (item.phone_number || "").toLowerCase().includes(q) ||
        (item.address || "").toLowerCase().includes(q)
    );
  };

  useEffect(() => {
    const sideTab = localStorage.getItem("navOption");
    if (sideTab !== "/drivers") {
      setDriverSelection(1);
      setPageSelection(1);
      setList(1);
      setPage(1);
      fetchDriverList(1, 1);
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (getPageSelection()) {
      setPage(getPageSelection());
    } else {
      setPageSelection(1);
      setList(1);
      fetchDriverList(1, 1);
    }
    if (getDriverSelection()) {
      setList(getDriverSelection());
      handleRequestData(parseInt(getDriverSelection()));
    } else {
      setList(1);
      setDriverSelection(1);
    }
    setList(getDriverSelection());
  }, []);

  const InReview = () => {
    setList(1);
    setInput('');
    setDriverSelection(1);
    setPage(1);
    fetchDriverList(1, 1, input);
  };

  const Approved = () => {
    setList(2);
    setInput('');
    setDriverSelection(2);
    setPage(1);
    fetchDriverList(2, 1, input);
  };

  const OnHold = () => {
    setList(3);
    setInput('');
    setDriverSelection(3);
    setPage(1);
    fetchDriverList(3, 1, input);
  };

  const Reject = () => {
    setList(4);
    setInput('');
    setDriverSelection(4);
    setPage(1);
    fetchDriverList(4, 1, input);
  };

  const history = useHistory();

  const partnerlist = (selected) => {
    switch (selected) {
      case 1:
        return <List from="driver" status="in_review" data={filterBySearch(inReviewRequest)} onClick={() => history.push("/drivers/inreview")} />;
      case 2:
        return <List from="driver" status="approved" data={filterBySearch(approvedDrivers)} onClick={() => history.push("/drivers/inreview")} />;
      case 3:
        return <List from="driver" status="OnHold" data={filterBySearch(OnHoldDrivers)} onClick={() => history.push("/drivers/inreview")} />;
      case 4:
        return <List from="driver" status="rejected" data={filterBySearch(rejectedDrivers)} onClick={() => history.push("/drivers/inreview")} />;
      default:
        return <List from="driver" status="inReview" data={filterBySearch(inReviewRequest)} onClick={() => history.push("/drivers/inreview")} />;
    }
  };


  let loadshimmer = <ContentLoader
  speed={2}
  width={"1000px"}
  height={750}
  backgroundColor="#f3f3f3"
  foregroundColor="#ecebeb"
  style={{marginLeft:-29,marginTop:-25}}
>
    <rect x="51" y="45" rx="3" ry="3" width="1006" height="17" />
    <circle cx="879" cy="123" r="11" />
    <circle cx="914" cy="123" r="11" />
    <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
    <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
    <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
    <rect x="55" y="155" rx="3" ry="3" width="997" height="2" />
    <circle cx="880" cy="184" r="11" />
    <circle cx="915" cy="184" r="11" />
    <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
    <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
    <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
    <rect x="56" y="216" rx="3" ry="3" width="997" height="2" />
    <circle cx="881" cy="242" r="11" />
    <circle cx="916" cy="242" r="11" />
    <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
    <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
    <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
    <rect x="57" y="274" rx="3" ry="3" width="997" height="2" />
    <circle cx="882" cy="303" r="11" />
    <circle cx="917" cy="303" r="11" />
    <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
    <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
    <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
    <rect x="58" y="335" rx="3" ry="3" width="997" height="2" />
    <circle cx="881" cy="363" r="11" />
    <circle cx="916" cy="363" r="11" />
    <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
    <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
    <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
    <rect x="57" y="395" rx="3" ry="3" width="997" height="2" />
    <circle cx="882" cy="424" r="11" />
    <circle cx="917" cy="424" r="11" />
    <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
    <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
    <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
    <rect x="55" y="453" rx="3" ry="3" width="997" height="2" />
    <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
    <rect x="997" y="49" rx="3" ry="3" width="2" height="465" />
    <circle cx="882" cy="484" r="11" />
    <circle cx="917" cy="484" r="11" />
    <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
    <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
    <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
    <rect x="55" y="513" rx="3" ry="3" width="997" height="2" />
    <rect x="52" y="80" rx="3" ry="3" width="1006" height="17" />
    <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
    <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
    <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
    <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
    <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
    </ContentLoader>
  return (
    <div className="drivers">
      <Header title={translate('drivers')} />
      <div className='drivers-header'>
        <p className='partner-database'>{/* translate('partnerDatabse') */}</p>
        <Button title={translate('addNewDriver')} onClick={() => history.push('/drivers/becomeadriver')} style={{ width: 177, height: 35 }} />
      </div>
      <Titlebar onClick1={InReview} onClick2={Approved} onClick3={OnHold} onClick4={Reject} onSearch={onSearch} input={input}
        active={list} title1={translate('inReview')} title2={translate('approved')} title3={translate('OnHold')} title4={translate('reject')}
      />

      {!loading ?
        <div>
          <section className="shortlisted">

            {
              partnerlist(list)
            }
          </section>
          <div className="campaign-pagination-bottom" style={{ justifyContent: 'flex-end' }}>
          {  count>10 && !input?.trim() ?<Pagination
             firstPageText={<i class="fa fa-angle-left" aria-hidden="true"></i>}
             prevPageText={<i class="fa fa-angle-double-left" aria-hidden="true"></i>}
             lastPageText={<i class="fa fa-angle-right" aria-hidden="true"></i>}
             nextPageText={<i class="fa fa-angle-double-right" aria-hidden="true"></i>}
            activePage={activePage}
            itemsCountPerPage={10}
            totalItemsCount={count}
            onChange={handlePageChange}
            activeClass="active"
            activeLinkClass="active"
            hideDisabled
          /> :''}
        </div>
      </div>
        : <section className="shortlisted">

        {loadshimmer}
        </section>
      }
    </div>
  )
}

export default Driver